// extracted by mini-css-extract-plugin
export var dropdownButton = "_2d-0";
export var fullWidthDropdownButton = "_2d-1";
export var icon = "_2d-3";
export var iconPlaceholder = "_2d-2";
export var shortcutContainer = "_2d-4";